import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['circle'];
  static values = {
    progress: String
  }

  connect() {
    const circumference = this.circleTarget.r.baseVal.value * 2 * Math.PI;
    const pct = Math.min(100, Math.max(0, parseFloat(this.progressValue) || 0));

    this.circleTarget.style.strokeDasharray = `${circumference} ${circumference}`;
    this.circleTarget.style.strokeDashoffset = `${circumference - (pct / 100) * circumference}`;
  }
}